import { VrockFileHandler } from './VrockFileHandler';

export class BackupInSession {
  readonly PROJECT_LOG = 'project_log';
  /**
   *
   * @param {ログをローカルストレージに１００件残す} project_id
   * @param {*} project
   */
  appendLog(project_id: string, xml: string, code: string): void {
    const logItem = this.getLogs();

    // ログは１００件まで（１００件超えたら古いものから消す）
    if (logItem.length > 100) {
      logItem.splice(0, 1);
    }

    // 最後に書いたログが同じ情報だったら、保存しない
    const lastLog = logItem[logItem.length - 1];
    if (lastLog !== null && typeof lastLog !== 'undefined' && lastLog.block_xml === xml && lastLog.js_code === code) {
      return;
    }

    const exporter = new VrockFileHandler();
    const vrock: VrockFileHandler = exporter.toVrockBackupObject(xml, code, project_id);
    logItem.push(vrock);
    localStorage.setItem(this.PROJECT_LOG, JSON.stringify(logItem));
  }

  getLogs(): VrockFileHandler[] {
    const logItemJson = localStorage.getItem(this.PROJECT_LOG);
    let logItem = [];
    if (logItemJson !== null) {
      logItem = JSON.parse(logItemJson);
    }
    return logItem;
  }
}
